module.exports = __webpack_public_path__ + "fonts/NespressoLucas-SemiBd.ttf?v=043776659bb73c051c279ac8e53d1d1d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-SemiBd.ttf
// module id = 674
// module chunks = 0